module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueParcours_Cerave.f1dfc230.png";